import { render, staticRenderFns } from "./DocumentModificatorList.vue?vue&type=template&id=085aa940"
import script from "./DocumentModificatorList.vue?vue&type=script&lang=js"
export * from "./DocumentModificatorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports